// originally from:
// https://github.com/drozhzhin-n-e/ng2-tooltip-directive

import { Component,
         ElementRef,
         HostListener,
         HostBinding,
         Input,
         OnInit,
         EventEmitter, 
         OnChanges,
         OnDestroy,
         SimpleChanges} from '@angular/core'
import { LcpHelper } from '../../_core/_helpers/lcp-helper'

@Component({
  selector: 'lcp-content-block',
  templateUrl: 'content-block.component.html',
  styleUrls: ['content-block.component.scss'],
  host: {'class': 'lcp-content-block'},
})

export class ContentBlockComponent implements OnInit, OnChanges, OnDestroy {

  @Input('block') block: any
  // @Input() klass: any

  constructor(
    protected lcpHelper: LcpHelper,
    // private el: ElementRef
  ) {}

  // events = new EventEmitter()

  ngOnInit(): void {
    // console.log('media', this.media)
  }

  ngAfterViewInit(): void {
    // console.log('media', this.media)
    // if (this.klass &&this.el.nativeElement) {
    //   this.klass.split(" ").forEach(k => this.el.nativeElement.classList.add(k))
    // }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('media-chg', changes)
  }

  ngOnDestroy(): void {
    
  }

  // detectChanges() {
    
  // }
}
